/**
 * The header of the « Créer » page on a creation wizard — its title and
 * subtitle, shown by createPage/CreatePage.tsx on the wizard's route —, the
 * same words for every type: Odoo's wizard (`plugins/odoo`, its
 * `wizardTitle.ts`) and the generic one (`GenericProjectWizard`). Apart from
 * the wizard itself, so that the page does not pull the lazily loaded wizard
 * into its own chunk.
 */

/** « Nouveau projet Wagtail », from the type's title (`metadata.title`). */
export const createWizardTitle = (typeTitle: string) =>
  `Nouveau projet ${typeTitle}`;

export const CREATE_WIZARD_SUBTITLE =
  'Un dépôt GitLab, puis l’environnement dev sur son propre sous-domaine.';
